
    // Surface any module-load errors visibly. (Default: silent in console.)
    // Module errors that matter will be re-thrown by the dev tools console
    // anyway; we only show them in the status bar as a fallback.
    window.addEventListener('error', (e) => {
      const msg = e.message || e.error?.message || 'unknown';
      const s = document.getElementById('status');
      if (s) s.textContent = 'ERROR: ' + msg;
      console.error('window error:', e);
    });
    window.addEventListener('unhandledrejection', (e) => {
      const s = document.getElementById('status');
      if (s) s.textContent = 'PROMISE ERROR: ' + (e.reason?.message || e.reason);
      console.error('unhandled rejection:', e);
    });
  